import { useEffect, useState } from "react";
import Select from "react-select";
import { useLanguage } from "../../context/Language/LanguageContext";

function VideoFilters({
  matches,
  team,
  teamAPlayers,
  teamBPlayers,
  games,
  rotations,
  eventTypes,
  eventResults,
  attackTypes,
  hitTypes,
  blockTypes,
  attackCombos,
  setterCalls,
  powerPlayOptions,
  allFilters,
  onDoFilters,
  onCancel,
  //   selectedTeamAPlayers,
  //   selectedTeamBPlayers,
  //   selectedGames,
  //   selectedRotations,
  //   selectedEventTypes,
  //   selectedEventResults,
  //   selectedAttackTypes,
  //   selectedHitTypes,
  //   selectedBlockTypes,
  //   selectedAttackCombos,
  //   selectedSetterCalls,
}) {
  const { t } = useLanguage();
  const [, forceUpdate] = useState(0);
  const [selectedTeamAPlayers, setSelectedTeamAPlayers] = useState([]);
  const [selectedTeamBPlayers, setSelectedTeamBPlayers] = useState([]);
  const [selectedGames, setSelectedGames] = useState([]);
  const [selectedRotations, setSelectedRotations] = useState([]);
  const [selectedEventTypes, setSelectedEventTypes] = useState([]);
  const [selectedEventResults, setSelectedEventResults] = useState([]);
  const [selectedAttackTypes, setSelectedAttackTypes] = useState([]);
  const [selectedHitTypes, setSelectedHitTypes] = useState([]);
  const [selectedBlockTypes, setSelectedBlockTypes] = useState([]);
  const [selectedAttackCombos, setSelectedAttackCombos] = useState([]);
  const [selectedSetterCalls, setSelectedSetterCalls] = useState([]);
  const [selectedPowerPlay, setSelectedPowerPlay] = useState([]);

  useEffect(() => {
    setSelectedTeamAPlayers(allFilters ? allFilters.teamAPlayers : []);
    setSelectedTeamBPlayers(allFilters ? allFilters.teamBPlayers : []);
    setSelectedGames(allFilters ? allFilters.games : []);
    setSelectedRotations(allFilters ? allFilters.rotations : []);
    setSelectedEventTypes(allFilters ? allFilters.eventTypes : []);
    setSelectedEventResults(allFilters ? allFilters.eventResults : []);
    setSelectedAttackTypes(allFilters ? allFilters.attackTypes : []);
    setSelectedHitTypes(allFilters ? allFilters.hitTypes : []);
    setSelectedBlockTypes(allFilters ? allFilters.blockTypes : []);
    setSelectedAttackCombos(allFilters ? allFilters.attackCombos : []);
    setSelectedSetterCalls(allFilters ? allFilters.setterCalls : []);
    setSelectedPowerPlay(allFilters ? allFilters.powerPlay : []);
    forceUpdate((n) => !n);
  // `allFilters` only changes reference when the parent explicitly opens the
  // modal or applies new filters (see VideoAnalysis.jsx doFilters/onFilters) —
  // do NOT add other props here. A previous `updated` prop was a brand-new
  // inline arrow function created on every VideoAnalysis render (video
  // timeupdate/live-refresh ticks fire very often), so including it in this
  // dependency array re-ran this reset effect constantly, snapping the user's
  // freshly-picked selection back to allFilters almost immediately.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allFilters]);

  const doFilters = () => {
    onDoFilters({
      teamAPlayers: selectedTeamAPlayers,
      teamBPlayers: selectedTeamBPlayers,
      eventTypes: selectedEventTypes,
      eventResults: selectedEventResults,
      attackTypes: selectedAttackTypes,
      hitTypes: selectedHitTypes,
      blockTypes: selectedBlockTypes,
      attackCombos: selectedAttackCombos,
      setterCalls: selectedSetterCalls,
      games: selectedGames,
      rotations: selectedRotations,
      powerPlay: selectedPowerPlay,
    });
  };

  function handleSelectPowerPlay(data) {
    if (data.length === 0) {
      setSelectedPowerPlay(data);
      return;
    }
    if (data[0].value === 0 && data.length > 1) {
      var ddd = [];
      for (var nd = 1; nd < data.length; nd++) {
        ddd.push(data[nd]);
      }
      setSelectedPowerPlay(ddd);
      return;
    } else if (data[data.length - 1].value === 0 && data.length > 1) {
      setSelectedPowerPlay([data[data.length - 1]]);
      return;
    }
    setSelectedPowerPlay(data);
  }

  function handleSelectEventTypes(data) {
    if (data.length === 0) {
      setSelectedEventTypes(data);
      return;
    }
    if (data[0].value === 0 && data.length > 1) {
      var ddd = [];
      for (var nd = 1; nd < data.length; nd++) {
        ddd.push(data[nd]);
      }
      setSelectedEventTypes(ddd);
      return;
    } else if (data[data.length - 1].value === 0 && data.length > 1) {
      setSelectedEventTypes([data[data.length - 1]]);
      return;
    }
    setSelectedEventTypes(data);
  }

  function handleSelectGames(data) {
    if (data.length === 0) {
      setSelectedGames(data);
      return;
    }
    if (data[0].value === 0 && data.length > 1) {
      var ddd = [];
      for (var nd = 1; nd < data.length; nd++) {
        ddd.push(data[nd]);
      }
      setSelectedGames(ddd);
      return;
    } else if (data[data.length - 1].value === 0 && data.length > 1) {
      setSelectedGames([data[data.length - 1]]);
      return;
    }
    setSelectedGames(data);
  }

  function handleSelectRotations(data) {
    if (data.length === 0) {
      setSelectedRotations(data);
      return;
    }
    if (data[0].value === 0 && data.length > 1) {
      var ddd = [];
      for (var nd = 1; nd < data.length; nd++) {
        ddd.push(data[nd]);
      }
      setSelectedRotations(ddd);
      return;
    } else if (data[data.length - 1].value === 0 && data.length > 1) {
      setSelectedRotations([data[data.length - 1]]);
      return;
    }
    setSelectedRotations(data);
  }

  function handleSelectEventResults(data) {
    if (data.length === 0) {
      setSelectedEventResults(data);
      return;
    }
    if (data[0].value === 0 && data.length > 1) {
      var ddd = [];
      for (var nd = 1; nd < data.length; nd++) {
        ddd.push(data[nd]);
      }
      setSelectedEventResults(ddd);
      return;
    } else if (data[data.length - 1].value === 0 && data.length > 1) {
      setSelectedEventResults([data[data.length - 1]]);
      return;
    }
    setSelectedEventResults(data);
  }

  function handleSelectAttackTypes(data) {
    if (data.length === 0) {
      setSelectedAttackTypes(data);
      return;
    }
    if (data[0].value === 0 && data.length > 1) {
      var ddd = [];
      for (var nd = 1; nd < data.length; nd++) {
        ddd.push(data[nd]);
      }
      setSelectedAttackTypes(ddd);
      return;
    } else if (data[data.length - 1].value === 0 && data.length > 1) {
      setSelectedAttackTypes([data[data.length - 1]]);
      return;
    }
    setSelectedAttackTypes(data);
  }

  function handleSelectHitTypes(data) {
    if (data.length === 0) {
      setSelectedHitTypes(data);
      return;
    }
    if (data[0].value === 0 && data.length > 1) {
      var ddd = [];
      for (var nd = 1; nd < data.length; nd++) {
        ddd.push(data[nd]);
      }
      setSelectedHitTypes(ddd);
      return;
    } else if (data[data.length - 1].value === 0 && data.length > 1) {
      setSelectedHitTypes([data[data.length - 1]]);
      return;
    }
    setSelectedHitTypes(data);
  }

  function handleSelectBlockTypes(data) {
    if (data.length === 0) {
      setSelectedBlockTypes(data);
      return;
    }
    if (data[0].value === 6 && data.length > 1) {
      var ddd = [];
      for (var nd = 1; nd < data.length; nd++) {
        ddd.push(data[nd]);
      }
      setSelectedBlockTypes(ddd);
      return;
    } else if (data[data.length - 1].value === 6 && data.length > 1) {
      setSelectedBlockTypes([data[data.length - 1]]);
      return;
    }
    setSelectedBlockTypes(data);
  }

  function handleSelectAttackCombos(data) {
    if (data.length === 0) {
      setSelectedAttackCombos(data);
      return;
    }
    if (data[0].value === 0 && data.length > 1) {
      var ddd = [];
      for (var nd = 1; nd < data.length; nd++) {
        ddd.push(data[nd]);
      }
      setSelectedAttackCombos(ddd);
      return;
    } else if (data[data.length - 1].value === 0 && data.length > 1) {
      setSelectedAttackCombos([data[data.length - 1]]);
      return;
    }
    setSelectedAttackCombos(data);
  }

  function handleSelectSetterCalls(data) {
    if (data.length === 0) {
      setSelectedSetterCalls(data);
      return;
    }
    if (data[0].value === 0 && data.length > 1) {
      var ddd = [];
      for (var nd = 1; nd < data.length; nd++) {
        ddd.push(data[nd]);
      }
      setSelectedSetterCalls(ddd);
      return;
    } else if (data[data.length - 1].value === 0 && data.length > 1) {
      setSelectedSetterCalls([data[data.length - 1]]);
      return;
    }
    setSelectedSetterCalls(data);
  }

  function handleSelectTeamAPlayers(data) {
    if (data.length === 0) {
      setSelectedTeamAPlayers(data);
      return;
    }
    if (data[0].value === 0 && data.length > 1) {
      var ddd = [];
      for (var nd = 1; nd < data.length; nd++) {
        ddd.push(data[nd]);
      }
      setSelectedTeamAPlayers(ddd);
      return;
    } else if (data[data.length - 1].value === 0 && data.length > 1) {
      setSelectedTeamAPlayers([data[data.length - 1]]);
      return;
    }
    setSelectedTeamAPlayers(data);
  }

  function handleSelectTeamBPlayers(data) {
    if (data.length === 0) {
      setSelectedTeamBPlayers(data);
      return;
    }
    if (data[0].value === 0 && data.length > 1) {
      var ddd = [];
      for (var nd = 1; nd < data.length; nd++) {
        ddd.push(data[nd]);
      }
      setSelectedTeamBPlayers(ddd);
      return;
    } else if (data[data.length - 1].value === 0 && data.length > 1) {
      setSelectedTeamBPlayers([data[data.length - 1]]);
      return;
    }
    setSelectedTeamBPlayers(data);
  }

  // NOTE: this app runs daisyUI v3, whose CSS custom properties (--b1, --b2,
  // --b3, --p, --bc, ...) hold RAW HSL components (e.g. "0 0% 100%"), meant to
  // be consumed via hsl(var(--x)) — NOT oklch() (that's a daisyUI v4/v5
  // convention). Wrapping them in oklch() produces an invalid color at
  // computed-value time, which the browser resolves to its initial value
  // (transparent for backgrounds) — this is why the dropdown menus were see-
  // through and unusable.
  const getSelectedTheme = (theme) => {
return ({
      ...theme.colors,
      primary: "hsl(var(--p))",
      primary25: "hsl(var(--b3) / 0.5)",
      neutral0: "hsl(var(--b1))",
    });
  };

  const customStyles = {
    control: (baseStyles, state) => ({
      ...baseStyles,
      // height: 34,
      borderRadius: 6,
      backgroundColor: "hsl(var(--b2))",
      color: "hsl(var(--bc))",
      // backgroundColor: "rgba(255, 255, 255, 0.05)",
      // borderColor: state.isFocused ? "oklch(var(--p))" : "transparent",
      // ":hover": {
      //   borderColor: "transparent",
      // },
    }),
    clearIndicator: (baseStyles, state) => ({
      ...baseStyles,
      color: "hsl(var(--bc) / 0.5)",
      ":hover": { color: "hsl(var(--bc))" },
    }),
    dropdownIndicator: (baseStyles, state) => ({
      ...baseStyles,
      color: "hsl(var(--bc) / 0.5)",
      ":hover": { color: "hsl(var(--bc))" },
    }),
    valueContainer: (baseStyles, state) => ({
      ...baseStyles,
      padding: "0 8px",
    }),
    input: (baseStyles, state) => ({
      ...baseStyles,
      color: "hsl(var(--bc))",
    }),
    singleValue: (baseStyles, state) => ({
      ...baseStyles,
      color: "hsl(var(--bc))",
    }),
    multiValue: (baseStyles, state) => ({
      ...baseStyles,
      backgroundColor: "hsl(var(--b2))",
    }),
    multiValueLabel: (baseStyles, state) => ({
      ...baseStyles,
      color: "hsl(var(--bc))",
    }),
    multiValueRemove: (baseStyles, state) => ({
      ...baseStyles,
      color: "hsl(var(--bc) / 0.5)",
      ":hover": {
        backgroundColor: "rgba(255, 255, 255, 0.2)",
        color: "hsl(var(--bc))",
      },
    }),
    // menu/menuList/option were previously unstyled and relied entirely on
    // theme.colors (see getSelectedTheme) for background — explicit styles
    // here guarantee a solid, readable background regardless of theme.
    menu: (baseStyles) => ({
      ...baseStyles,
      backgroundColor: "hsl(var(--b1))",
      color: "hsl(var(--bc))",
    }),
    menuList: (baseStyles) => ({
      ...baseStyles,
      backgroundColor: "hsl(var(--b1))",
    }),
    // Render the menu in a portal (see menuPortalTarget on each <Select>
    // below) so it escapes the modal's overflow/stacking context instead of
    // being clipped or trapped behind the modal backdrop — that was also
    // preventing clicks on options from registering.
    menuPortal: (baseStyles) => ({ ...baseStyles, zIndex: 99999 }),
    option: (baseStyles, state) => ({
      ...baseStyles,
      backgroundColor: state.isSelected
        ? "hsl(var(--p))"
        : state.isFocused
        ? "hsl(var(--b3))"
        : "hsl(var(--b1))",
      color: state.isSelected ? "hsl(var(--pc))" : "hsl(var(--bc))",
      cursor: "pointer",
    }),
  };

  return (
    <div>
      <h3 className="mb-4 font-bold text-2xl">{t("Filters")}</h3>
      <div className="form">
        <div className="my-4 text-base-content">
          <div className="flex justify-between mt-4">
            <div className="flex=col justify-between w-full mx-2">
              <p className="text-xs">
                {matches.length === 1 ? matches[0].teamA.Name : team} {t("Players")}
              </p>
              <Select
                id="teamAPlayersSelect"
                name="teamAPlayersSelect"
                onChange={handleSelectTeamAPlayers}
                className="mt-2 block w-full border-gray-300 shadow-sm focus:border-gray-500 focus:ring-gray-500text-sm"
                options={teamAPlayers}
                value={selectedTeamAPlayers}
                isMulti
                menuPortalTarget={document.body}
                styles={customStyles}
                theme={theme => ({
                  ...theme,
                  colors: {
                    ...getSelectedTheme(theme),
                  }})}
              />
            </div>
            <div className="flex=col justify-between w-full mx-2">
              <p className="text-xs">
                {matches.length === 1 ? matches[0].teamB.Name : t("Opponents")}{" "}
                {t("Players")}
              </p>
              <Select
                id="teamBPlayersSelect"
                name="teamBPlayersSelect"
                onChange={handleSelectTeamBPlayers}
                className="mt-2 block w-full border-gray-300 shadow-sm focus:border-gray-500 focus:ring-gray-500text-sm"
                options={teamBPlayers}
                value={selectedTeamBPlayers}
                isMulti
                menuPortalTarget={document.body}
                styles={customStyles}
                theme={theme => ({
                  ...theme,
                  colors: {
                    ...getSelectedTheme(theme),
                  }})}
              />
            </div>
          </div>

          <div className="flex justify-between mt-4">
            <div className="flex=col justify-between w-full mx-2">
              <p className="text-xs">{t("Sets")}</p>
              <Select
                id="gamesSelect"
                name="gamesSelect"
                onChange={handleSelectGames}
                className="mt-2 block w-full border-gray-300 shadow-sm focus:border-gray-500 focus:ring-gray-500text-sm"
                options={games}
                value={selectedGames}
                isMulti
                menuPortalTarget={document.body}
                styles={customStyles}
                theme={theme => ({
                  ...theme,
                  colors: {
                    ...getSelectedTheme(theme),
                  }})}
              />
            </div>

            <div className="flex=col justify-between w-full mx-2">
              <p className="text-xs">{t("Rotation")}</p>
              <Select
                id="rotationsSelect"
                name="rotationsSelect"
                onChange={handleSelectRotations}
                className="mt-2 block w-full border-gray-300 shadow-sm focus:border-gray-500 focus:ring-gray-500text-sm"
                options={rotations}
                value={selectedRotations}
                isMulti
                menuPortalTarget={document.body}
                styles={customStyles}
                theme={theme => ({
                  ...theme,
                  colors: {
                    ...getSelectedTheme(theme),
                  }})}
              />
            </div>
          </div>
          <div className="flex justify-between mt-4">
            <div className="flex=col justify-between w-full mx-2">
              <p className="text-xs">{t("Event Type")}</p>
              <Select
                id="eventTypesSelect"
                name="eventTypesSelect"
                onChange={handleSelectEventTypes}
                className="mt-2 block w-full border-gray-300 shadow-sm focus:border-gray-500 focus:ring-gray-500text-sm"
                options={eventTypes}
                value={selectedEventTypes}
                isMulti
                menuPortalTarget={document.body}
                styles={customStyles}
                theme={theme => ({
                  ...theme,
                  colors: {
                    ...getSelectedTheme(theme),
                  }})}
              />
            </div>
            <div className="flex=col justify-between w-full mx-2">
              <p className="text-xs">{t("Event Result")}</p>
              <Select
                id="eventResultsSelect"
                name="eventResultsSelect"
                onChange={handleSelectEventResults}
                className="mt-2 block w-full border-gray-300 shadow-sm focus:border-gray-500 focus:ring-gray-500text-sm"
                options={eventResults}
                value={selectedEventResults}
                isMulti
                menuPortalTarget={document.body}
                styles={customStyles}
                theme={theme => ({
                  ...theme,
                  colors: {
                    ...getSelectedTheme(theme),
                  }})}
              />
            </div>
          </div>
          <div className="flex justify-between mt-4">
            <div className="flex=col justify-between w-full mx-2">
              <p className="text-xs">{t("Attack Type")}</p>
              <Select
                id="attackTypesSelect"
                name="attackTypesSelect"
                onChange={handleSelectAttackTypes}
                className="mt-2 block w-full border-gray-300 shadow-sm focus:border-gray-500 focus:ring-gray-500text-sm"
                options={attackTypes}
                value={selectedAttackTypes}
                isMulti
                menuPortalTarget={document.body}
                styles={customStyles}
                theme={theme => ({
                  ...theme,
                  colors: {
                    ...getSelectedTheme(theme),
                  }})}
              />
            </div>
            <div className="flex=col justify-between w-full mx-2">
              <p className="text-xs">{t("Hit Type")}</p>
              <Select
                id="hitTypesSelect"
                name="hitTypesSelect"
                onChange={handleSelectHitTypes}
                className="mt-2 block w-full border-gray-300 shadow-sm focus:border-gray-500 focus:ring-gray-500text-sm"
                options={hitTypes}
                value={selectedHitTypes}
                isMulti
                menuPortalTarget={document.body}
                styles={customStyles}
                theme={theme => ({
                  ...theme,
                  colors: {
                    ...getSelectedTheme(theme),
                  }})}
              />
            </div>
            <div className="flex=col justify-between w-full mx-2">
              <p className="text-xs">{t("Block Type")}</p>
              <Select
                id="blockTypesSelect"
                name="blockTypesSelect"
                onChange={handleSelectBlockTypes}
                className="mt-2 block w-full border-gray-300 shadow-sm focus:border-gray-500 focus:ring-gray-500text-sm"
                options={blockTypes}
                value={selectedBlockTypes}
                isMulti
                menuPortalTarget={document.body}
                styles={customStyles}
                theme={theme => ({
                  ...theme,
                  colors: {
                    ...getSelectedTheme(theme),
                  }})}
              />
            </div>
          </div>
          <div className="flex justify-between mt-4">
            <div className="flex=col justify-between w-full mx-2">
              <p className="text-xs">{t("Attack Combo")}</p>
              <Select
                id="attackCombosSelect"
                name="attackCombosSelect"
                onChange={handleSelectAttackCombos}
                className="mt-2 block w-full border-gray-300 shadow-sm focus:border-gray-500 focus:ring-gray-500text-sm"
                options={attackCombos}
                value={selectedAttackCombos}
                isMulti
                menuPortalTarget={document.body}
                styles={customStyles}
                theme={theme => ({
                  ...theme,
                  colors: {
                    ...getSelectedTheme(theme),
                  }})}
              />
            </div>
            <div className="flex=col justify-between w-full mx-2">
              <p className="text-xs">{t("Setter's Call")}</p>
              <Select
                id="setterCallsSelect"
                name="setterCallsSelect"
                onChange={handleSelectSetterCalls}
                className="mt-2 block w-full border-gray-300 shadow-sm focus:border-gray-500 focus:ring-gray-500text-sm"
                options={setterCalls}
                value={selectedSetterCalls}
                isMulti
                menuPortalTarget={document.body}
                styles={customStyles}
                theme={theme => ({
                  ...theme,
                  colors: {
                    ...getSelectedTheme(theme),
                  }})}
              />
            </div>
          </div>
          <div className="flex justify-between mt-4">
            <div className="flex=col justify-between w-full mx-2">
              <p className="text-xs">{t("Power Play")}</p>
              <Select
                id="powerPlaySelect"
                name="powerPlaySelect"
                onChange={handleSelectPowerPlay}
                className="mt-2 block w-full border-gray-300 shadow-sm focus:border-gray-500 focus:ring-gray-500text-sm"
                options={powerPlayOptions}
                value={selectedPowerPlay}
                isMulti
                menuPortalTarget={document.body}
                styles={customStyles}
                theme={theme => ({
                  ...theme,
                  colors: {
                    ...getSelectedTheme(theme),
                  }})}
              />
            </div>
          </div>
        </div>
        <div className="flex gap-2 justify-end">
          <div className="modal-action">
            <button
              type="button"
              className="btn-in-form"
              onClick={() => onCancel?.()}
            >
              {t("Cancel")}
            </button>
          </div>
          <div className="modal-action">
            <button
              htmlFor="modal-filters"
              className="btn-in-form"
              onClick={() => doFilters()}
            >
              {t("Apply")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default VideoFilters;
